import { Card } from "antd";
import { useTranslation } from "react-i18next";

const ProfitLossCard = ({ profitLossData }) => {
    const { t, i18n } = useTranslation();

    console.log("profitLossData", profitLossData);

    return (
        <Card className="col-span-12 md:col-span-6 shadow rounded-2xl">
            <div className="flex-1 overflow-y-auto h-full space-y-3 pe-2 scrollbar-none mt-4">
                {profitLossData.map((item) => {
                    const isPercentage =
                        item.id === "profit_percentage" ||
                        item.id === "net_profit_percentage";

                    return (
                        <div
                            key={item.id}
                            className={`py-3 px-4 rounded-lg ${item.id === "net_profit_percentage"
                                    ? "bg-gradient-to-r from-[#E3F0F9] to-[#E7F2EB]"
                                    : ""
                                }`}
                            style={
                                item.id !== "net_profit_percentage"
                                    ? { backgroundColor: item.bg_color }
                                    : {}
                            }
                        >
                            <div className="flex items-center justify-between">
                                <span className="text-sm font-semibold text-gray-700">
                                    {item.label}
                                </span>

                                <span
                                    className={`font-bold ${item.id === "net_profit_percentage"
                                            ? "text-lg text-[#7EC242]"
                                            : "text-sm text-gray-900"
                                        }`}
                                >
                                    {isPercentage
                                        ? `${item.value}%`
                                        : `EGP ${item.value.toLocaleString()}`}
                                </span>
                            </div>

                            {/* Progress bar only for Net Profit Percentage */}
                            {/* {item.id === "net_profit_percentage" && (
                                <div className="mt-2 w-full h-2 bg-[#7EC2421F] rounded-full overflow-hidden">
                                    <div
                                        className="h-2 rounded-full bg-[#7EC242]"
                                        style={{ width: `${item.value}%` }}
                                    />
                                </div>
                            )} */}
                        </div>
                    );
                })}
            </div>
        </Card>
    );
};

export default ProfitLossCard;
